import type { FaireProductEntity } from "../../entity_types/product";

export const p_2bfzvcqu4h: FaireProductEntity = {
  token: "p_2bfzvcqu4h",
  type: "product",
  name: "Miss Sparkling Mommy and Me Curly Knit Cardigan",
  brandToken: "b_erg8vzmjsk",
  brandName: "Miss Sparkling",
  imageUrl:
    "https://cdn.faire.com/fastly/e649d21dace85581e121921cc5a0d8bb1b3a18a3ccaf4a7741644e050e00aff9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/50caf90d55d2b1412efbb0b7cadb9929c2225a9f18fe71ad1e7c22aa71b9b92d.jpeg",
    "https://cdn.faire.com/fastly/e147ebdf6f23b47a838f508fe541fe7abf2b415739eaa39a2fc5530a105dd165.jpeg",
  ],
  priceDollars: 794.83,
  description:
    "-Plush, shaggy curly knit fabric with a fluffy, tactile look, creating a cozy, playful, and eye-catching aesthetic for the whole family.\n-Round neckline, full button-front closure, ribbed cuffs and hem, and a cropped fit that balances warmth and style.\n-Identical design for mom and daughter, perfect for creating sweet, coordinated family looks for photoshoots or cold-weather outings.\n-Easily pairs with jeans, skirts, or dresses; great for casual outings, family trips, holiday gatherings, or as a thoughtful gift.\n",
  tags: [],
  msrpDollars: 1589.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:26.462Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
